import { SharedFunctions } from './../shared.functions';
import { HttpClient } from '@angular/common/http';
import { MaterialDto, SaveMaterialDto, SearchMaterialRequest } from './../model/materiales';
import { Injectable } from '@angular/core';
import { CrudService } from './crud.service';

@Injectable({
  providedIn: 'root'
})
export class MaterialesService extends CrudService<MaterialDto, number, SaveMaterialDto, SearchMaterialRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'Material', sharedFunctions);
  }
}